import React from "react";
import { ChevronIcon, StarIcon } from "./StoreSelectorIcons.tsx";

interface Props {
  label: string;
  isOpen: boolean;
  onClick: () => void;
}

export default function StoreSelectorTrigger({ label, isOpen, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-haspopup="listbox"
      aria-expanded={isOpen}
      className={[
        // layout
        "inline-flex items-center gap-2.5 h-10 px-4 rounded-sm",
        // border + bg
        "border border-[rgba(var(--border-gold))] transition-all duration-200 outline-none",
        "bg-surface-2 text-text-primary",
        isOpen
          ? "border-gold-2 shadow-[0_0_0_3px_rgba(var(--color-gold-1)/0.15)]"
          : "border-[rgb(var(--border-secondary))] hover:border-gold-2/60 hover:bg-surface-3",
        // text
        "whitespace-nowrap cursor-pointer select-none",
        "min-w-[200px]",
      ].join(" ")}
    >
      {/* SCOPE label */}
      <span className="text-[9px] font-bold tracking-[0.12em] uppercase text-gold-2 shrink-0 leading-0">
        SCOPE
      </span>

      {/* Divider */}
      <span className="w-px h-4 bg-[rgb(var(--border-secondary))] shrink-0 opacity-60" />

      {/* Star + store name */}
      <span className="flex items-center text-text-primary gap-1.5 flex-1 min-w-0">
        <span className="shrink-0 flex">
          <StarIcon />
        </span>
        <span className="text-[12px] font-medium truncate tracking-tight">
          {label}
        </span>
      </span>

      {/* Chevron */}
      <span className="text-text-muted shrink-0 flex">
        <ChevronIcon open={isOpen} />
      </span>
    </button>
  );
}
